module.exports = __webpack_public_path__ + "static/img/4141_phase_function_Paper_Points.748b2a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4141_phase_function_Paper_Points.png
// module id = MI0c
// module chunks = 0